import React, { Component } from 'react';
import BillablePscPanel from "./BillablePscPanel";
import Modal from "./Modal";
import { connect } from "react-redux";
import { commonService } from "../../_services";
import { alertActions, commonActions} from "../../_actions";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { EmptyRecord } from "../../utils/PageUtility";
import { store } from "../../_store";
import { Grid } from "@material-ui/core";


class BillablePscSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            billablePassengers: [],
            checkInfant: false,
            checkAdult: false,
            checkChild: false,
            adultKey: "A",
            childKey: "C",
            infantKey: "I",
            requestingData: true,
            billableRecord: false,
            createBillablePscEntityTypeId: null,
        };


    }

    componentDidMount() {
        const reduxState = store.getState();
        let { entityTypes, user } = reduxState;
        const { dispatch } = this.props;

        if (user.AppRole === appConstants.ROLES.VGG_ADMIN) {
            if (!entityTypes) {
                dispatch(commonActions.getEntityTypes())
            } else {
                this.setEntityTypes(entityTypes)
            }
        }

        this.getBillablePassengers();
        this.markCheckBoxes();


    }

    componentWillReceiveProps = function (nextProps) {
        const { entityTypes, user } = nextProps;

        if (user.AppRole === appConstants.ROLES.VGG_ADMIN && entityTypes) {
            this.setEntityTypes(entityTypes)
        }
    };

    // method to get entity types from store and set in state
    setEntityTypes = (entityTypes) => {
        let createBillablePscEntityTypeId;

        entityTypes.forEach(entity => {
            if (entity.EntityType === appConstants.APP_ENTITIES.BILLABLE_PASSENGER_SETTINGS) {
                createBillablePscEntityTypeId = entity.EntityTypeId;
            }

        });
        this.setState({ createBillablePscEntityTypeId })

    };

    //method to get all billable passengers from endpoint and set in state
    getBillablePassengers = () => {
        const { dispatch } = this.props;

        dispatch(alertActions.startRequest());

        commonService.getBillablePassengersRegional()
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ billablePassengers: response, requestingData: false, billableRecord: true });
                    this.markCheckBoxes();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingData: false });
                }
            })
    };

    //method to add new billable passengers.
    saveBillablePassengers = () => {
        const { checkAdult, checkInfant, checkChild, adultKey, childKey,
            infantKey, createBillablePscEntityTypeId } = this.state;
        const { user } = this.props;
        const { dispatch } = this.props;
        let keys = [];
        let payload = {};
        if (checkAdult) {        //if adult is checked
            keys.push(adultKey);     //Push the value of adult to keys array
            payload.SettingKey = keys   //set SettingKey parameter in payload to keys
        }
        if (checkChild) {       //if child is checked
            keys.push(childKey);    //Push the value of child to keys array
            payload.SettingKey = keys     //set SettingKey parameter in payload to keys
        }

        if (checkInfant) {               //if child is checked
            keys.push(infantKey);      //Push the value of child to keys array
            payload.SettingKey = keys //set SettingKey parameter in payload to keys
        }

        //payload for maker checker payloadViewTemplate
        let payloadTemplate = {
            SettingKey: keys,

        };

        //payload to send to maker checker
        let makerCheckerPayload = {
            AppId: appConstants.MAKER_CHECKER_APP_ID,
            Payload: JSON.stringify(payloadTemplate),
            PayloadViewTemplate: JSON.stringify(payloadTemplate),
            URL: `${appConstants.PAS_URL}/api/BillablePassenger/AddBillablePassengerPSCR`,
            EntityTypeId: createBillablePscEntityTypeId,
            CreatedBy: user.userName
        };
        
        dispatch(alertActions.startRequest());
        commonService.createMakerChecker(makerCheckerPayload)   //end point call
            .then(res => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify("Billable Passenger sent Successfully"));
                    this.handleClose();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));

                }
            });

        /* Previous logic to call add billable passenger endpoint directly before maker checker*/
        // dispatch(alertActions.stopRequest());
        // commonService.saveBillablePassengers(payload)
        // .then((res) => {
        //     dispatch(alertActions.stopRequest());
        //     if(res.status === appConstants.SUCCESS_RESPONSE) {
        //         dispatch(alertActions.notify("Billable Passenger Added Successfully"));
        //         this.handleClose();
        //         this.getBillablePassengers();
        //     }
        //     else if(res.status === appConstants.ERROR_RESPONSE) {
        //         dispatch(alertActions.error(res.response));
        //     }
        // })
    };

    // method to toggle billable passenger check boxes
    toggleCheck = (pscType) => {
        this.setState({ [pscType]: !this.state[pscType] });

    };

    //method to mark billable passengers check boxes
    markCheckBoxes = () => {
        const { adultKey, childKey, infantKey, billablePassengers } = this.state;

        //If key parameter in billable passenger matches any of the billable passenger keys in state
        //set the corresponding check value in state to true
        billablePassengers.forEach(item => {
            if (item.Key === adultKey) {
                this.setState({ checkAdult: true })
            } else if (item.Key === childKey) {
                this.setState({ checkChild: true })
            } else if (item.Key === infantKey) {
                this.setState({ checkInfant: true })
            }
        })
    };

    //method to close Set billable passengers modal
    handleClose = () => {
        this.setState({
            isOpen: false
        })
    };

    //method to open Set billable passengers modal
    handleOpenModal = () => {
        this.setState({ isOpen: true })
    };

    render() {
        const { isOpen, billablePassengers, checkChild, checkInfant, adultKey,
            checkAdult, childKey, infantKey, requestingData, billableRecord } = this.state;

        //if an API call is being made, show circular progress
        if (requestingData)
            return (
                <CircularProgress />
            );

        return (
            <div>
                <Grid container spacing={24} justify="center" alignItems="center">
                    <GridItem xs={12} sm={12} md={8}>
                        <Card>
                            <CardHeader color="regional">
                                <h4>
                                    Current Billable Passenger
                        </h4>
                            </CardHeader>
                            <CardBody className={'billableCardBody'}>
                                {
                                    billableRecord
                                    &&
                                    <BillablePscPanel
                                        handleOpenModal={this.handleOpenModal}
                                        billablePassengers={billablePassengers}

                                    />
                                }
                                {
                                    !billableRecord
                                    &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <EmptyRecord message={'No billable passenger record'} />
                                        </GridItem>
                                    </GridContainer>
                                }
                            </CardBody>
                        </Card>
                    </GridItem>
                </Grid>
                <Modal
                    handleClose={this.handleClose}
                    handleSubmit={this.saveBillablePassengers}
                    isOpen={isOpen}
                    checkChild={checkChild}
                    checkAdult={checkAdult}
                    checkInfant={checkInfant}
                    adultKey={adultKey}
                    childKey={childKey}
                    infantKey={infantKey}
                    toggleCheck={this.toggleCheck}
                    disabled={this.props.requesting}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { alert, user, users, requesting, entityTypes } = state;
    return {
        alert,
        user,
        users,
        requesting,
        entityTypes
    };
}

export default connect(mapStateToProps)(BillablePscSettings);

/*Written with love by Juliet April 2019*/



// WEBPACK FOOTER //
// ./src/Regional-Views/BillablePscSettings/Index.jsx